export type VeloraTheme = 'dark' | 'light' | 'cosmos'

export interface ThemeColors {
  bg: string; bgDark: string;
  glassBg: string; glassBgStrong: string;
  glassBorder: string; glassBorderStrong: string;
  glassShadow: string;
  card: string; cardBorder: string;
  primary: string; light: string; accent: string;
  text: string; muted: string; dim: string;
  orb1: string; orb2: string; orb3: string; orb4: string;
  nav: string; navBorder: string; headerGrad: string;
}

export const THEMES: Record<VeloraTheme, ThemeColors> = {
  dark: {
    // base
    bg:         '#050210',
    bgDark:     '#030118',
    // glass surfaces
    glassBg:    'rgba(255,255,255,0.055)',
    glassBgStrong: 'rgba(255,255,255,0.095)',
    glassBorder: 'rgba(255,255,255,0.10)',
    glassBorderStrong: 'rgba(255,255,255,0.18)',
    glassShadow: '0 8px 32px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.13)',
    // legacy compat
    card:       'rgba(255,255,255,0.055)',
    cardBorder: 'rgba(255,255,255,0.10)',
    // accent
    primary:    '#534AB7',
    light:      '#7F77DD',
    accent:     '#9B94E8',
    // text
    text:       '#EEEDFE',
    muted:      'rgba(238,237,254,0.55)',
    dim:        'rgba(238,237,254,0.30)',
    // orb background blobs
    orb1: 'radial-gradient(circle, rgba(83,74,183,0.55) 0%, transparent 70%)',
    orb2: 'radial-gradient(circle, rgba(127,119,221,0.35) 0%, transparent 70%)',
    orb3: 'radial-gradient(circle, rgba(168,85,247,0.25) 0%, transparent 70%)',
    orb4: 'radial-gradient(circle, rgba(30,27,75,0.8) 0%, transparent 70%)',
    // nav
    nav:        'rgba(5,2,16,0.72)',
    navBorder:  'rgba(255,255,255,0.07)',
    headerGrad: 'transparent',
  },
  light: {
    bg:         '#ece9ff',
    bgDark:     '#ddd8ff',
    glassBg:    'rgba(255,255,255,0.55)',
    glassBgStrong: 'rgba(255,255,255,0.75)',
    glassBorder: 'rgba(255,255,255,0.70)',
    glassBorderStrong: 'rgba(255,255,255,0.90)',
    glassShadow: '0 8px 32px rgba(83,74,183,0.12), inset 0 1px 0 rgba(255,255,255,0.8)',
    card:       'rgba(255,255,255,0.55)',
    cardBorder: 'rgba(255,255,255,0.70)',
    primary:    '#534AB7',
    light:      '#7F77DD',
    accent:     '#534AB7',
    text:       '#1a1535',
    muted:      'rgba(26,21,53,0.55)',
    dim:        'rgba(26,21,53,0.35)',
    orb1: 'radial-gradient(circle, rgba(83,74,183,0.18) 0%, transparent 70%)',
    orb2: 'radial-gradient(circle, rgba(127,119,221,0.12) 0%, transparent 70%)',
    orb3: 'radial-gradient(circle, rgba(168,85,247,0.10) 0%, transparent 70%)',
    orb4: 'radial-gradient(circle, rgba(216,212,252,0.5) 0%, transparent 70%)',
    nav:        'rgba(236,233,255,0.82)',
    navBorder:  'rgba(83,74,183,0.12)',
    headerGrad: 'transparent',
  },
  cosmos: {
    bg:         '#020108',
    bgDark:     '#010106',
    glassBg:    'rgba(255,255,255,0.045)',
    glassBgStrong: 'rgba(255,255,255,0.085)',
    glassBorder: 'rgba(255,255,255,0.09)',
    glassBorderStrong: 'rgba(255,255,255,0.16)',
    glassShadow: '0 8px 32px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.10)',
    card:       'rgba(255,255,255,0.045)',
    cardBorder: 'rgba(255,255,255,0.09)',
    primary:    '#7F77DD',
    light:      '#9B94E8',
    accent:     '#B8B3F0',
    text:       '#EEEDFE',
    muted:      'rgba(238,237,254,0.50)',
    dim:        'rgba(238,237,254,0.25)',
    orb1: 'radial-gradient(circle, rgba(127,119,221,0.5) 0%, transparent 70%)',
    orb2: 'radial-gradient(circle, rgba(67,56,202,0.4)  0%, transparent 70%)',
    orb3: 'radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)',
    orb4: 'radial-gradient(circle, rgba(15,12,50,0.9) 0%, transparent 70%)',
    nav:        'rgba(2,1,8,0.80)',
    navBorder:  'rgba(255,255,255,0.06)',
    headerGrad: 'transparent',
  },
}
